import config from '../config/app'
import axios from 'axios'

const PATH = '/membership/payment'
export default {
  pay (transactionReference) {
    let url = config.server + PATH + '/pay'
    return new Promise((resolve, reject) => {
      axios.post(url, {transaction_reference: transactionReference}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getStatus (id) {
    let url = config.server + PATH + '/status/' + id
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  refundPayment (data) {
    let url = config.server + PATH + '/refund'
    return new Promise((resolve, reject) => {
      axios.post(url, data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getById (id, additional) {
    return new Promise((resolve, reject) => {
      this.get({id: id}, additional).then((response) => {
        resolve(response.data[0])
      }, (error) => {
        reject(error)
      })
    })
  },
  getByRef (id, additional) {
    return new Promise((resolve, reject) => {
      this.get({transaction_reference: id}, additional).then((response) => {
        resolve(response.data[0])
      }, (error) => {
        reject(error)
      })
    })
  },
  getByUser (userId, filters, additional) {
    let params = typeof filters === 'object' && filters !== null ? filters : {}
    params.user_id = userId
    return this.get(params, additional)
  },
  get (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + PATH + '?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  create (fields) {
    let url = config.server + PATH
    return new Promise((resolve, reject) => {
      axios.post(url, fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  createPayment (fields) {
    let url = config.server + PATH + '/createPayment'
    return new Promise((resolve, reject) => {
      axios.post(url, fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  update (id, fields) {
    let url = config.server + PATH
    return new Promise((resolve, reject) => {
      axios.post(url + '/' + id, fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  removePayment (id) {
    let url = config.server + PATH
    return new Promise((resolve, reject) => {
      axios.delete(url + '/' + id).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  downloadPaymentReceipt (id, userId, paymentId = 0) {
    let url = config.server + PATH + '/receipt'
    let headers = new Headers()
    let token = localStorage.getItem('token')
    let authToken = token.indexOf('Bearer') > -1 ? token : 'Bearer ' + token
    headers.append('Authorization', authToken)
    let params = ''
    if (paymentId) {
      params = '?membership_id=' + id + '&user_id=' + userId + '&payment_id=' + paymentId
    } else {
      params = '?membership_id=' + id + '&user_id=' + userId
    }
    return fetch(url + params, {headers}).then(response => response.blob())
  },
  downloadRefundPaymentReceipt (id, userId, paymentId = 0) {
    let url = config.server + PATH + '/refund-receipt'
    let headers = new Headers()
    let token = localStorage.getItem('token')
    let authToken = token.indexOf('Bearer') > -1 ? token : 'Bearer ' + token
    headers.append('Authorization', authToken)
    let params = ''
    if (paymentId) {
      params = '?membership_id=' + id + '&user_id=' + userId + '&payment_id=' + paymentId
    } else {
      params = '?membership_id=' + id + '&user_id=' + userId
    }
    return fetch(url + params, {headers}).then(response => response.blob())
  },
  activateInstalment (token, membershipId, paymentId, userId) {
    let url = config.server + PATH + '/activate'
    return new Promise((resolve, reject) => {
      axios.post(url, {token: token, membership_id: membershipId, payment_id: paymentId, user_id: userId}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/membershipPayment.js